<template>
  <base-content-block>
    <template #title>{{ $t('src/pages/coursesadd.2159') }}</template>
    <template #content>
      <course-add-form
        v-model="course"
        :server-error="serverError"
        :saving="saving"
        @submit="saveCourse"
        @change="clearServerError"
        >{{ $t('button.saveAndContinue') }}</course-add-form
      >
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { status } from '@/main.config.js'
import { userRights } from '@/mixins/user-rights.js'
import { courseTypes, DATE_FORMAT } from '@/main.config'
import { contentTpl } from '@/mixins/content-tpl.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'CoursesAdd',
  mixins: [userRights, contentTpl, systemUnavailable],
  components: {
    CourseAddForm: () => import('@/components/CourseAddForm.vue')
  },
  data: () => ({
    course: {
      patient_id: null,
      doctor_id: null,
      start_date: null,
      course_type: courseTypes.rehab,
      status: status.plan
    },
    saving: false,
    serverError: null
  }),
  created() {
    this.course.start_date = this.moment.utc().format(DATE_FORMAT.server)
    if (this.isDoctor) {
      this.course.doctor_id = this.$store.getters.AUTH_USER.id
    }
    if (this.$route.query && this.$route.query.patient) {
      this.course.patient_id = +this.$route.query.patient
    }
  },
  methods: {
    saveCourse() {
      this.saving = true
      http
        .post('/courses', this.course)
        .then(response => {
          this.course = response.data
        })
        .then(() => {
          this.goToBinding()
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          this.serverError = error.response.status
        })
        .finally(() => {
          this.saving = false
        })
    },
    clearServerError() {
      this.serverError = null
    },
    goToBinding() {
      if (this.course.id) {
        this.$router.push({
          name: 'new-course-binding',
          params: { id: this.course.id, status: this.course.status }
        })
      }
    }
  }
}
</script>
